import { AppBar, Box, SvgIcon, Toolbar } from '@mui/material';
import { OpenGovLogoBlurple } from '@opengov/react-capital-assets';
import { HEADER_HEIGHT, TestIds } from '../../constants';

/**
 * Simplified Header for unauthenticated routes.
 *
 * Renders the OpenGov logo without any auth-dependent elements
 * (no user profile, entity selector, notifications, or sidebar toggle).
 */
export function UnauthenticatedHeader() {
  return (
    <AppBar
      data-testid={TestIds.UNAUTH_HEADER}
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
        flexShrink: 0,
      }}
    >
      <Toolbar sx={{ height: HEADER_HEIGHT, minHeight: HEADER_HEIGHT }}>
        <Box sx={{ display: 'flex', alignItems: 'center', px: 1 }}>
          <SvgIcon
            component={OpenGovLogoBlurple}
            inheritViewBox
            sx={{ width: 120, height: 'auto' }}
          />
        </Box>

        <Box flexGrow={1} />
      </Toolbar>
    </AppBar>
  );
}
